import { updatesItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              动态快讯
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              按时间线追踪最新爆料，不错过每一个瓜
            </p>
          </div>

          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-[11px] md:left-[15px] top-2 bottom-2 w-0.5 bg-background-200"></div>

            <div className="space-y-0">
              {updatesItems.map((item, i) => (
                <div key={i} className="relative pb-8 last:pb-0">
                  <div className="absolute left-[-25px] md:left-[-27px] top-1.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 z-10"></div>
                  <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                    <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded whitespace-nowrap shrink-0 w-fit">
                      {item.date}
                    </span>
                    <div className="flex-grow">
                      <p className="text-sm md:text-base text-foreground-800 leading-relaxed hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                        {item.title}
                      </p>
                      <span className="text-xs text-foreground-400 mt-1 inline-block">
                        {item.time}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}